import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { IArticleBase } from '../../../types'
import styles from './index.module.scss'
import { ArticleItemList } from '../ArticleItemList'
import { NoContent } from '../../atoms/NoContent'
import { PrimaryHeadingWithLink } from '../../atoms/PrimaryHeadingWithLink'

type Props = {
  articles: IArticleBase[]
  companySlug: string
}

export const CompanyProfileArticle: FC<Props> = ({ articles, companySlug }) => {
  const { t } = useTranslation(['companies-[id]'])

  return (
    <div className={styles.container}>
      <PrimaryHeadingWithLink htmlTagType='h2' href={`/companies/${companySlug}/articles`}>
        {t('ストーリー')}
      </PrimaryHeadingWithLink>
      {articles.length === 0 ? (
        <NoContent>{t('ストーリーがまだ登録されていません。')}</NoContent>
      ) : (
        <ArticleItemList items={articles} />
      )}
    </div>
  )
}
